import React from 'react';

const StepOneBasic = ({ data, onChange, errors }) => {
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    onChange({ [name]: value });
    
    // Clear error when user starts typing
    if (errors[name]) {
      errors[name] = '';
    }
  };

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Full Name */}
        <div>
          <label htmlFor="fullName" className="block text-sm font-medium mb-2" style={{color: '#3E3E3E'}}>
            Full Name *
          </label>
          <input
            type="text"
            id="fullName"
            name="fullName"
            value={data.fullName}
            onChange={handleInputChange}
            className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent transition-colors ${
              errors.fullName ? 'border-red-500' : 'border-stone-300'
            }`}
            placeholder="Enter your full name"
            style={{focusRingColor: '#C8A96A'}}
          />
          {errors.fullName && (
            <p className="mt-1 text-sm text-red-500">{errors.fullName}</p>
          )}
        </div>

        {/* Phone Number */}
        <div>
          <label htmlFor="phoneNumber" className="block text-sm font-medium mb-2" style={{color: '#3E3E3E'}}>
            Phone Number *
          </label>
          <input
            type="tel"
            id="phoneNumber"
            name="phoneNumber"
            value={data.phoneNumber}
            onChange={handleInputChange}
            className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent transition-colors ${
              errors.phoneNumber ? 'border-red-500' : 'border-stone-300'
            }`}
            placeholder="+91 98765 43210"
            style={{focusRingColor: '#C8A96A'}}
          />
          {errors.phoneNumber && (
            <p className="mt-1 text-sm text-red-500">{errors.phoneNumber}</p>
          )}
        </div>
      </div>

      {/* Email Address */}
      <div>
        <label htmlFor="emailAddress" className="block text-sm font-medium mb-2" style={{color: '#3E3E3E'}}>
          Email Address *
        </label>
        <input
          type="email"
          id="emailAddress"
          name="emailAddress"
          value={data.emailAddress}
          onChange={handleInputChange}
          className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent transition-colors ${
            errors.emailAddress ? 'border-red-500' : 'border-stone-300'
          }`}
          placeholder="your.email@example.com"
          style={{focusRingColor: '#C8A96A'}}
        />
        {errors.emailAddress && (
          <p className="mt-1 text-sm text-red-500">{errors.emailAddress}</p>
        )}
      </div>

      {/* City / Location */}
      <div>
        <label htmlFor="cityLocation" className="block text-sm font-medium mb-2" style={{color: '#3E3E3E'}}>
          City / Location *
        </label>
        <input
          type="text"
          id="cityLocation"
          name="cityLocation"
          value={data.cityLocation}
          onChange={handleInputChange}
          className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent transition-colors ${
            errors.cityLocation ? 'border-red-500' : 'border-stone-300'
          }`}
          placeholder="Enter your city or location"
          style={{focusRingColor: '#C8A96A'}}
        />
        {errors.cityLocation && (
          <p className="mt-1 text-sm text-red-500">{errors.cityLocation}</p>
        )}
      </div>

      {/* Info Card */}
      <div className="p-4 rounded-lg" style={{backgroundColor: '#F5EFE6'}}>
        <div className="flex items-start gap-3">
          <span className="material-symbols-outlined text-lg mt-1" style={{color: '#C8A96A'}}>
            info
          </span>
          <div>
            <h4 className="font-medium mb-1" style={{color: '#3E3E3E'}}>Why we need this information</h4>
            <p className="text-sm text-stone-600">
              Your basic details help us understand your location and contact preferences to provide personalized consultation services.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StepOneBasic;
